<template>
	<div class="basic_wrap">
		<div class="header-title">
			<van-icon name="arrow-left" class="back-icon" @click="$router.back()" />
			在线支付
		</div>
		<div class="content">
			<div class="paymentDetails">
				<div class="left">
					<img :src="currentImg" />
				</div>
				<div class="right">
					<div class="price">￥ {{ paymentPrice }}元</div>
					<div class="text">{{ paymentContent }}</div>
				</div>
			</div>
			<div class="paymentMethod">
				<div class="top">
					<p class="title">请选择支付方式</p>
				</div>
				<div class="bottom">
					<div class="methodList" :class="{active: paymentMethod === 1}" @click="selectPaymentMethod(1)">
						<div class="methodIcon">
							<img src="@/assets/icon/onlinePayment/UnionPay.png" />
						</div>
						<div class="methodName">银联卡支付</div>
						<div class="selectIcon">
							<img v-if="paymentMethod === 1" src="@/assets/icon/onlinePayment/selected.png" />
							<img v-else src="@/assets/icon/onlinePayment/NotSelected.png" />
						</div>
					</div>
					<div class="methodList" :class="{active: paymentMethod === 2}" @click="selectPaymentMethod(2)">
						<div class="methodIcon">
							<img src="@/assets/icon/onlinePayment/WeChat.png" />
						</div>
						<!-- <div class="methodName">微信支付</div> -->
						<div class="methodName">微信支付（一）</div>
						<div class="selectIcon">
							<img v-if="paymentMethod === 2" src="@/assets/icon/onlinePayment/selected.png" />
							<img v-else src="@/assets/icon/onlinePayment/NotSelected.png" />
						</div>
					</div>
					<div class="methodList" :class="{active: paymentMethod === 'S02'}"
						@click="selectPaymentMethod('S02')">
						<div class="methodIcon">
							<img src="@/assets/icon/onlinePayment/WeChat.png" />
						</div>
						<div class="methodName">微信支付（二）</div>
						<div class="selectIcon">
							<img v-if="paymentMethod === 'S02'" src="@/assets/icon/onlinePayment/selected.png" />
							<img v-else src="@/assets/icon/onlinePayment/NotSelected.png" />
						</div>
					</div>
					<div class="methodList" :class="{active: paymentMethod === 3}" @click="selectPaymentMethod(3)">
						<div class="methodIcon">
							<img src="@/assets/icon/onlinePayment/Alipay.png" />
						</div>
						<!-- <div class="methodName">支付宝支付</div> -->
						<div class="methodName">支付宝支付（一）</div>
						<div class="selectIcon">
							<img v-if="paymentMethod === 3" src="@/assets/icon/onlinePayment/selected.png" />
							<img v-else src="@/assets/icon/onlinePayment/NotSelected.png" />
						</div>
					</div>
					<div class="methodList" :class="{active: paymentMethod === 'S05'}"
						@click="selectPaymentMethod('S05')">
						<div class="methodIcon">
							<img src="@/assets/icon/onlinePayment/Alipay.png" />
						</div>
						<div class="methodName">支付宝支付（二）</div>
						<div class="selectIcon">
							<img v-if="paymentMethod === 'S05'" src="@/assets/icon/onlinePayment/selected.png" />
							<img v-else src="@/assets/icon/onlinePayment/NotSelected.png" />
						</div>
					</div>
					<div class="methodList" :class="{active: paymentMethod === 'S07'}"
						@click="selectPaymentMethod('S07')">
						<div class="methodIcon">
							<img src="@/assets/icon/onlinePayment/Alipay.png" />
						</div>
						<div class="methodName">支付宝支付（三）</div>
						<div class="selectIcon">
							<img v-if="paymentMethod === 'S07'" src="@/assets/icon/onlinePayment/selected.png" />
							<img v-else src="@/assets/icon/onlinePayment/NotSelected.png" />
						</div>
					</div>
				</div>
			</div>
			<div class="tip">
				<img :src="currentTipImg" />
			</div>
			<div class="payBtn" @click="handlePay" :disabled="isPaying">
				{{ isPaying ? '支付处理中...' : '立即支付' }}
			</div>
		</div>

		<van-overlay :show="loading" z-index="999">
			<div class="loading-overlay">
				<van-loading type="spinner" color="#1989fa" />
				<div class="loading-text">加载中...</div>
			</div>
		</van-overlay>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import coinImg from '@/assets/icon/onlinePayment/coin.png';
	import cardImg from '@/assets/icon/onlinePayment/card.png';
	import voucherImg from '@/assets/icon/onlinePayment/voucher.png';
	import taxImg from '@/assets/icon/onlinePayment/tax.png';
	import tip1Img from '@/assets/icon/onlinePayment/tip1.png';
	import tip2Img from '@/assets/icon/onlinePayment/tip2.png';
	import tip3Img from '@/assets/icon/onlinePayment/tip3.png';
	import tip4Img from '@/assets/icon/onlinePayment/tip4.png';
	import tip5Img from '@/assets/icon/onlinePayment/tip5.png';
	import tip6Img from '@/assets/icon/onlinePayment/tip6.png';
	import tip7Img from '@/assets/icon/onlinePayment/tip7.png';
	export default {
		name: "onlinePayment",
		data() {
			return {
				coinImg: coinImg,
				cardImg: cardImg,
				voucherImg: voucherImg,
				taxImg: taxImg,
				tip1Img: tip1Img,
				tip2Img: tip2Img,
				tip3Img: tip3Img,
				tip4Img: tip4Img,
				tip5Img: tip5Img,
				tip6Img: tip6Img,
				tip7Img: tip7Img,
				currentImg: null,
				currentTipImg: null,
				paymentPrice: null,
				paymentContent: null,
				paymentMethod: 1, // 支付方式：1-银联 2-微信 3-支付宝 S05-S07-S02
				loading: false,
				isPaying: false,
				id: null
			};
		},
		created() {
			this.$parent.footer('onlinePayment', false);
			this.id = this.$route.query.id;
			this.setCurrentImg(); // 根据id设置图片
			this.fetchPaymentInfo();
		},
		methods: {
			// 根据id设置当前显示的图片
			setCurrentImg() {
				// 将id转换为数字进行比较，因为路由参数可能是字符串
				const idNum = parseInt(this.id);
				if (idNum === 0) {
					this.currentImg = this.coinImg;
					this.currentTipImg = this.tip1Img;
				} else if (idNum === 1) {
					this.currentImg = this.cardImg;
					this.currentTipImg = this.tip2Img;
				} else if (idNum === 2 || idNum === 3 || idNum === 4 || idNum === 5) {
					this.currentImg = this.cardImg;
					this.currentTipImg = this.tip3Img;
				} else if (idNum === 6) {
					this.currentImg = this.cardImg;
					this.currentTipImg = this.tip4Img;
				} else if (idNum === 7) {
					this.currentImg = this.cardImg;
					this.currentTipImg = this.tip5Img;
				} else if (idNum === 8) {
					this.currentImg = this.voucherImg;
					this.currentTipImg = this.tip6Img;
				} else if (idNum === 9) {
					this.currentImg = this.taxImg;
					this.currentTipImg = this.tip7Img;
				}
			},
			// 选择支付方式
			selectPaymentMethod(method) {
				this.paymentMethod = method;
			},
			fetchPaymentInfo() {
				this.loading = true;

				Fetch('/index/getPaymentInfo', {
						id: this.id
					}).then(res => {
						this.loading = false;

						if (res.code === 1) {
							this.paymentPrice = res.data.money;
							this.paymentContent = res.data.name;
						} else {
							this.$toast(res.message || '获取支付信息失败');
						}
					})
					.catch(error => {
						this.loading = false;
						console.error('获取支付信息失败:', error);
						this.$toast('网络错误，请稍后重试');
					});
			},
			getMappedPaymentMethod() {
				// 根据id参数映射支付方式
				if (this.paymentMethod === 'S02') {
					return 2; // 微信支付
				} else if (this.paymentMethod === 'S05' || this.paymentMethod === 'S07') {
					return 3; // 支付宝支付
				}
				// 其他情况使用用户选择的支付方式
				return this.paymentMethod;
			},
			handlePay() {
				if (!this.paymentPrice || !this.paymentContent) {
					this.$toast('支付信息加载中，请稍后');
					return;
				}

				if (!this.paymentMethod) {
					this.$toast('请选择支付方式');
					return;
				}
				this.isPaying = true;

				let productId = '';

				// 根据支付方式确定productId
				switch (this.paymentMethod) {
					case 1: // 银联
						productId = '8003';
						break;
					case 2: // 微信（一）
						productId = '8001';
						break;
					case 3: // 支付宝（一）
						productId = '8002';
						break;
					case 'S05': // 支付宝（二）
					case 'S07': // 支付宝（三）
					case 'S02': // 微信（一）
						// 新支付通道，productId就是通道编码
						productId = this.paymentMethod;
						break;
				}

				console.log('调用支付接口，支付方式:', this.paymentMethod, productId);
				this.$toast('正在跳转支付...');

				Fetch('/user/recharge_type', {
						// id: this.paymentMethod,
						id: this.getMappedPaymentMethod(),
						type: this.id,
						money: this.paymentPrice,
						reason: this.paymentContent,
						productId: productId,
					}).then(res => {
						this.isPaying = false;

						if (res.code === 1) {
							this.$toast('支付请求已发送');

							if (res.data.payUrl) {
								const queryParams = {
									payUrl: res.data.payUrl,
									orderId: res.data.orderId,
									id: this.id
								};

								this.$router.push({
									path: '/paymentIframe',
									query: queryParams
								});
							}
						} else {
							this.$toast(res.message || '支付失败');
						}
					})
					.catch(error => {
						this.isPaying = false;
						console.error('支付请求失败:', error);
						this.$toast('支付请求失败，请稍后重试');
					});
			}
		}
	};
</script>

<style lang="less" scoped>
	.basic_wrap {
		// height: 100vh;
		height: 100%;
		background-color: #f5f5f5;
		position: relative;
	}

	.header-title {
		position: relative;
		z-index: 1;
		width: 100%;
		text-align: center;
		font-size: 4.8vw;
		font-weight: 600;
		padding: 4vw 0;
		background: #fff;
		box-shadow: 0 1.06667vw 3.2vw rgba(0, 0, 0, .05);
		color: #333;
		border-bottom: 1px solid rgba(0, 0, 0, .05);

		.back-icon {
			position: absolute;
			left: 4vw;
			top: 50%;
			transform: translateY(-50%);
			font-size: 5.33333vw;
			color: #333;
		}
	}

	.content {
		padding: 4vw;
	}

	.paymentDetails {
		display: flex;
		align-items: center;
		background: #fff;
		border-radius: 2.66667vw;
		padding: 4vw;
		margin-bottom: 4vw;

		.left {
			// width: 25vw;
			height: 20vw;
			margin-right: 4vw;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.right {
			flex: 1;

			.price {
				font-size: 6vw;
				font-weight: bold;
				color: #FF8A00;
				margin-bottom: 2vw;
			}

			.text {
				color: #333;
				font-size: 5vw;
				font-weight: bold;
			}
		}
	}

	.paymentMethod {
		background: #fff;
		border-radius: 2.66667vw;
		overflow: hidden;
		margin-bottom: 4vw;

		.top {
			padding: 4vw;
			border-bottom: 1px solid #f0f0f0;

			.title {
				color: #333;
				font-size: 4.5vw;
				font-weight: bold;
				margin: 0;
			}
		}

		.bottom {
			.methodList {
				display: flex;
				align-items: center;
				padding: 4vw;
				border-bottom: 1px solid #f0f0f0;
				justify-content: space-between;

				&:last-child {
					border-bottom: none;
				}

				&.active {
					background-color: #f9f9f9;
				}

				.methodIcon {
					width: 15%;
					margin-right: 4vw;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.methodName {
					flex: 1;
					font-size: 4.26667vw;
					color: #333;
				}

				.selectIcon {
					width: 5.33333vw;
					height: 5.33333vw;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
	}

	.tip {
		padding: 3.2vw 4vw;
		margin-bottom: 8vw;

		img {
			width: 100%;
		}
	}

	.payBtn {
		width: 100%;
		height: 12vw;
		background: linear-gradient(90deg, #FF8A00 0%, #FFA940 100%);
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 5vw;
		color: #fff;
		font-weight: bold;
		position: fixed;
		bottom: 8vw;
		left: 4vw;
		right: 4vw;
		box-shadow: 0 2.66667vw 5.33333vw rgba(255, 138, 0, 0.3);
		letter-spacing: 2px; //字符间距

		&:active {
			opacity: 0.9;
		}
	}

	.loading-overlay {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100vh;

		.loading-text {
			margin-top: 20px;
			color: #fff;
			font-size: 16px;
		}
	}

	@media (max-width: 768px) {
		.payBtn {
			position: static;
			margin: 4vw 0;
		}
	}
</style>